/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import BadItemList from "../screens/BadItemList";
import layoutConf from "../../config/layoutConf";
import Button from "../input/Button";
import { CollectionView } from "@grapecity/wijmo";

import { cloneDeep } from "lodash";
import BasicStaticGridScreenType from "../screenTypes/functional/BasicStaticGridScreenType";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },
}));

function BadItemCreateDialog (props) {
    const {
        id, schema, process, moveable, resizable, fullWidth, maxWidth, onClose,
        onInitialized, initialData, onSuccess, ...others
    } = props;

    const  classes = useStyles ();
    const {t} = useTranslation ();

    const [instance, setInstance] = useState ();
    const [interaction, setInteraction] = useState(false);
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);
    const [failedLotList, setFailedLotList] = useState ([]);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [failedLotListSchema, setFailedLotListSchema] = useState();
    const [collectionView, setCollectionView] = useState();
    const [grid, setGrid] = useState();
    const [onSelectGrid, setOnSelectGrid] = useState();
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });
    
    useEffect(() => {
        if(schema) {
            let modifiedSchema = cloneDeep(schema);
            for( const column of modifiedSchema.columns) {
                switch(column.name) {
                    case "lotNo":
                        column.hideInForm = true;
                        break;

                    case "materialCode":
                        column.disabled = true;
                        break;

                    case "materialCodeVer":
                        column.disabled = true;
                        break;

                    case "materialName":
                        column.disabled = true;
                        break;
                    
                    case "materialTypeName":
                        column.hideInForm = true;
                        break;

                    case "wareHouseName":
                        column.hideInForm = true;
                        break;

                    case "wareHouseType":
                        column.hideInForm = true;
                        break;
                    
                    case "workState":
                        column.hideInForm = true;
                        break;

                    case "failureCode":
                        column.hideInForm = false;
                        column.formGroup = 1;
                        break;

                    case "qty":
                        column.hideInForm = false;
                        column.formGroup = 1;
                        break;

                    case "afterWarehouseCode":
                        column.hideInForm = false;
                        column.require = false;
                        column.formGroup = 0;
                        break;

                    case "processCode":
                        column.hideInForm = true;
                        break;

                    case "processId":
                        column.hideInForm = true;
                        break;

                    case "machineCode":
                        column.hideInForm = true;
                        break;

                    case "lineNo":
                        column.hideInForm = true;
                        break;

                    case "extLotNo":
                        column.hideInForm = true;
                        break;

                    case "qtyQueued":
                        column.hideInForm = false;
                        column.disabled = true;
                        break;
                    
                    case "inspectionDate":
                        column.hideInForm = true;
                        break;
    
                    default :
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const checkItemValidation = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation ("create", column, column.validation, formData[column.name] || "");
            if (!valid) {
                nofifyWarning (msg);
                return false;
            }
        }
        return true;
    }

    const nofifyWarning = (msg) => {
        console.warn(msg);
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);
        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onApiSuccess = (result) => {
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
            }
            return newFormData;
        });

        setKeepOpen ((keepOpen) => {
            if (!keepOpen) {
                instance.hide();
            }
            return keepOpen;
        });

        if (onSuccess) {
            onSuccess(result.data);
        }
    };

    const onApiFailure = (reason) => {
        notifyFailure (t(reason.response.data));
    };

    const onOk = () => {
        save(schema, formData);
    }

    function save(schema, formData) {
        if (!checkItemValidation(schema, formData)) {
            console.error("Form Validation Failed");
            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(
                formData,
                schema.validation
            );

            if (!valid) {
                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;
            }
        }

        let failQtySum = 0;
        for(const item of failedLotList) {
            failQtySum += item.qty;
        }

        if(failQtySum > initialData.qtyQueued) {
            nofifyWarning(t("warning.theDefectiveQuantityIsHigherThanTheCurrentQuantity"));
            return;
        }

        // build base api url
        let url = "/api/MomSysInspection/inspectionBadItem";
        let apiData = { ...formData };
        let form = new FormData ();
        let json = {};
        let deleted = {};

        //autoFormDialog columnMap 생성부분 
        if (schema) { 
            let columnMap = {};
            schema.columns.map(column => columnMap[column.name] = column);
            schema.columnMap = columnMap;
        }

        for(const formItem in apiData) {
            json[formItem] = apiData[formItem];
        }

        form.append ("deleted", JSON.stringify(deleted));
        // 서버(selfInspectionBadItem)는 행마다 대상 LOT 정보(lotNo · materialCode · wareHouseCode 등)를 읽는다
        form.append ("json", JSON.stringify(failedLotList.map((item) => ({ ...json, ...item }))));
        
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    }

    function notFileKey(columnMap, key) {
        if (columnMap && columnMap[key] && columnMap[key].formItemType !== "file") {
           return key;
        }
    }

    function notUndefined(apiData, key) {
        if(apiData !== undefined) {
            return key;
        }
    }

    const onCancel = () => {
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
                companyCode: undefined,
                description: undefined,
                cost: undefined,
                mainCustomer: undefined,
                minPurchaseQty: undefined,
            }
            return newFormData;
        });
        instance.hide();
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>
            </>
        )
    }

    const setInitialDataCallback = (formData) => {
        let keys = Object.keys(initialData);
        for(const key of keys) {
            formData[key] = initialData[key];
        }
    }

    const onChange = (formData) => {
        setFormData (formData);
        setInteraction (true);
    }

    const onCloseNotification = () => {
        setNotification((notification) => {
            return ({...notification, open: false});
        });
    };

    const onCloseDialog = () => {
        setInteraction (false);
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
                companyCode: undefined,
                description: undefined,
                cost: undefined,
                mainCustomer: undefined,
            }
            return newFormData;
        });
        setFailedLotList([]);
        
        if ( onClose ) {
            onClose ();
        }
    }

    
    const notifyWarning = (msg) => {
        console.warn (msg);
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onChangeFailedLotList = (failedLotList) => {
        setFailedLotList ( failedLotList );
    };

    const addFailedLot = (failedLotListSchema, formData) => {
        if(!checkItemValidation(failedLotListSchema, formData)) {
            console.error("Form Validation Failed");
            return;
        }

        if(formData.failureCode && formData.qty) {
            setFailedLotList((failedLotList) => {
                let lotList = cloneDeep(failedLotList);
                let lotInList = false;
                for(const lot of lotList) {
                    if(lot.failureCode === formData.failureCode) {
                        lot.qty += parseFloat(formData.qty);
                        lotInList = true;
                    }
                }

                if(!lotInList) {
                    lotList.push({ ...formData, qty: parseFloat(formData.qty) });
                }
                
                if(onChangeFailedLotList) {
                    onChangeFailedLotList(lotList);
                }
                return lotList;
            });
        }
    };

    const removeFailedLot = (failedLotListSchema, formData) => {
        if(!checkItemValidation(failedLotListSchema, formData)) {
            console.error("Form Validation Failed");
            return;
        }

        if(onSelectGrid) {
            setFailedLotList((failedLotList) => {
                let lotList = cloneDeep(failedLotList);
                let list = [];
                for(const item of lotList) {
                    if(item.failureCode !== onSelectGrid.failureCode) {
                        list.push(item);
                    }
                }

                if(onChangeFailedLotList) {
                    onChangeFailedLotList(list);
                }
                return list;
            });
        }
    };

    useEffect(()=> {
        setFormData({failureCode : '', decisionName : '', qty : ''})
        const schema = {
            name: "FailedLot",
            type: "BASE TABLE",
            searchAll: false,
            columns: [
                {
                    name: "failureCode",
                    type: "varchar(50)",
                    formOrder: 1,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "MomSysVwProcessingFailureCode",
                        nameColumn: ["decisionCode","decisionName"],
                        valueColumn: "decisionCode",
                        seperator: ": ",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    },
                    grid: {
                        columnOrder: 1,
                    },
                    visible: true,
                    width: "100%",
                    validation: false
                },
                {
                    name: "qty",
                    type: "float",
                    formOrder: 3,
                    formItemType: "float",
                    
                    grid: {
                        type : "number",
                        columnOrder: 3,
                    },
                    visible: true,
                    width: "100%",
                },
    
            ]
    
        };
        setFailedLotListSchema(schema);
    },[]);

    useEffect(() => {
        let collectionView = new CollectionView(failedLotList);
        setCollectionView(collectionView);
    }, [failedLotList]);
    
    const onGridInitialized = (grid) => {
        setGrid(grid);
    }

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectGrid(grid.selectedItems[0]);
                    } else {
                        setOnSelectGrid(undefined);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectGrid(grid.selectedItems[0]);
                    } else {
                        setOnSelectGrid(undefined);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >
            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.BadItemList" ) }
                </DialogTitle>
            </DialogHeaderWithClose>
        <Divider />

        <DialogContent style={{padding: "0px", height: "600px"}}>
            <ReflexContainer orientation="vertical">
                <ReflexElement flex={0.5} >
                    <BadItemList notifyWarning={notifyWarning} onChangeFailedLotList={onChangeFailedLotList} />
                    
                    <BasicStaticGridScreenType                        
                        id="product-fail-lot-list"
                        // headerTitle={t("term.productfailedLotList")}
                        schema={failedLotListSchema}
                        itemsSource={collectionView}
                        onInitialized={onGridInitialized}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }}/>

                <ReflexElement>
                    <div
                        style={{
                            padding: "16px"
                        }}                    
                    >
                        <div>
                            <AutoForm
                                id="bop-out-material-warehouse-form"
                                schema={modifiedSchema}
                                mode="edit"
                                initialData={initialData}
                                onChange={onChange}
                            />
                        </div>
                        <hr />
                        <Button 
                            id="RemoveProductFailedLot" 
                            color="secondary" 
                            style={{float: "right"}} 
                            onClick={() => removeFailedLot(failedLotListSchema, formData)}
                        >
                            {t("buttonName.removeFailedLot")}
                        </Button>
                        <Button 
                            id="AddProductFailedLot" 
                            color="primary" 
                            style={{float: "right"}} 
                            onClick={() => addFailedLot(failedLotListSchema, formData)}
                        >
                            {t("buttonName.addFailedLot")}
                        </Button>
                    </div>
                </ReflexElement>
            </ReflexContainer>

            <Snackbar
                open={notification.open && notification.severity !== "success"}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert
                    onClose={onCloseNotification}
                    variant="filled"
                    severity={notification.severity}
                >
                    {notification.msg}
                </Alert>
            </Snackbar>
        </DialogContent>
        <Divider />
        <DialogActionsOkCancel
            firstActionComponent={checkKeepOpen}
            labels={[ t("common.add")]}
            buttonDisabled={[!interaction, false]}
            onOk={() => onOk(schema, failedLotList, formData)}
            onCancel={onCancel}
        />
        </Dialog>
    );
}

export default BadItemCreateDialog;
